import PropTypes from "prop-types";
import React from "react";
import {MSpinner} from "components/Shared";
import { EmptyCard } from "components/Shared/EmptyCard";

const Files = ({
  isFetching,
  files,
  token
}) => {
  if (isFetching) {
    return<MSpinner/>;
  }

  if (!files) {
    return <MSpinner/>;
  }

  if  (!files.iframeUrlTemplate || !token) {
    return <EmptyCard message="Not Found." />;
  }

  return (
    <section className="case-header">
      <h4>Report Files</h4>
      <iframe
        id="files"
        width="100%"
        height="360"
        src={files.iframeUrlTemplate + "&SSO=" + encodeURI(token)}
        style={{ borderWidth: 0 }}
      />
    </section>);
};

Files.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  files: PropTypes.object,
  token: PropTypes.string
};

export default Files;